// @ts-check
import React from 'react';

/** @type {React.Context<import('./helpers/rooms').Room>} */
const RoomContext = React.createContext(undefined);

export default function useRoom() {
  return React.useContext(RoomContext);
}

/**
 * @param {{ value: import('./helpers/rooms').Room; children: React.ReactNode; }} props
 * @returns
 */
export function RoomProvider({ value, children }) {
  return <RoomContext.Provider value={value}>{children}</RoomContext.Provider>;
}
